import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {globalNamespace} from '../../../../helpers/models/namespaceHelpers';
import {buildContactForHandle, ContactSourcesEnum} from '../../../../models/api/contactModel';
import {MessageTypesEnum} from '../../../../models/api/messageModel';
import {RecipientRolesEnum} from '../../../../models/api/recipientModel';
import {VisualRecipientModel} from '../../../../models/api/visualRecipientModel';
import {AppState} from '../../../../store/appState';
import {makeGetSortedComposeChannels} from '../../../../store/data/channels/channelsSelectors';
import {composeMessageAction} from '../../../../store/data/messages/draftMessagesActions';
import {getIsUserVisitor} from '../../../../store/data/teammates/teammatesSelectors';
import {ContactCardHandleItem} from './contactCardHandleItem';

/*
 * Props.
 */

interface ContactCardHandleItemContainerProps {
  source: ContactSourcesEnum;
  messageType: MessageTypesEnum;
  handle: string;
}

/*
 * Selectors.
 */

function getMessageType(_state: AppState, props: ContactCardHandleItemContainerProps) {
  return props.messageType;
}

function getSource(_state: AppState, props: ContactCardHandleItemContainerProps) {
  return props.source;
}

function makeGetHasChannel() {
  return createSelector(
    [makeGetSortedComposeChannels({getSpecifiedMessageType: getMessageType}), getSource],
    (channels, source) =>
      channels.filter((channel) => channel.behaviors.supportedContactSources.includes(source)).length > 0,
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardHandleItemContainerProps>()(() => ({
  hasChannel: makeGetHasChannel(),
  isUserVisitor: getIsUserVisitor,
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactCardHandleItemContainerProps>()((props) => ({
  onComposeMessage: () => {
    const {handle, source} = props;
    // The namespace doesn't matter here since we're just opening the composer.
    const visualRecipient: VisualRecipientModel = {
      contact: buildContactForHandle(source, handle),
      namespace: globalNamespace,
      role: RecipientRolesEnum.TO,
    };
    return composeMessageAction({recipients: [visualRecipient], shouldForcePopout: true});
  },
}));

export const ContactCardHandleItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactCardHandleItem);
